import { GetResidentDetailsInput } from "@awc/models";
import { createAction } from "@reduxjs/toolkit";

export const GET_RECIPIENT_DETAILS = createAction<GetResidentDetailsInput>('GET_RECIPIENT_DETAILS')